/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EPaymentMethod } from "../types/EPaymentMethod.ts";

/**
 * @description 1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay |
 */
export const ePaymentMethodSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
  ])
  .describe(
    "1 = Billet | 2 = CreditCardAprovaFacil | 3 = CreditCardMundiPagg | 4 = BankDeposit | 5 = CreditCardStripe | 6 = BilletPecegePay | 7 = CreditCardPecegePay | ",
  ) as unknown as ToZod<EPaymentMethod>;
